module.exports = __webpack_public_path__ + "static/media/AppSumoAPILogo.345186d1.svg";